import {
    BaseReport,
    darkBarChartColor,
    darkerLightFirstColumnColor,
    lightFourthColumnColor,
    lightGreenColor,
    lightRedColor,
    lightSecondColumnColor,
    lightThirdColumnColor,
    PAGE_MARGIN,
} from './BaseReport';
// lodash
import {orderBy, uniqBy} from 'lodash';
import {IUsers} from '@/interfaces/commons/IUsers';
import {ISchool} from '@/interfaces/commons/ISchool';

/* tslint:disable:curly */
/* tslint:disable:no-console */

const fontSize: number = 8;

const lightColorArray: string[] = [
  lightGreenColor,
  lightFourthColumnColor,
  lightRedColor,
  lightThirdColumnColor,
];

class AnualCoverageReport extends BaseReport {

  constructor(user: IUsers, school: ISchool, dataToReport: any, logoURL: string) {
    super(user, school, dataToReport, logoURL);
  }



  public async downloadReport(): Promise<any> {
    let infoReport = this.constructData(this.dataToReport);
    const reportAnualCoverage = {
      content: this.buildAnualCoverageReport(infoReport),
    };
    return await this.generateReport(reportAnualCoverage, {
      reportTitle: 'COBERTURA CURRICULAR ANUAL - ' + this.school.yearSelected,
      firstTitle: this.dataToReport.category + (!!this.dataToReport.course ? (' ' + this.dataToReport.course) : ''),
      secondTitle: this.dataToReport.subject,
      reportType: this.dataToReport.reportType,
      emissionDate: this.dataToReport.emissionDate,
      id: this.dataToReport.idPlan,
    });
  }

  public constructData(data){

    let infoReport = {oasbase: {}, oasPlanificados: {}, oasRealizados :[], oasEnProceso: [], oasSinPlanificar: [], unidadesBase: [], aditionalsInProcess: [], aditionalsRealized: [], aditionalsNotPlanned: [], aditionalsOAs: []};

    data.unitPlans.forEach(
      (unit) => {
        unit.oas.forEach( oa => {
          if(oa.curricular){
            if(!infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]){
              infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura] = {};
            }          
            infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['codigo'] = oa.codigo;
            if(!infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['units']){
              infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['units'] = {}
            }
            if(!infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['ies']){
              infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['ies'] = [];
            }          
            oa.ies.forEach( ie => {
              if(ie.realizado && ie.realizado){              
                if(!infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['units'][unit.name]){
                  infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['units'][unit.name] = [];
                }
                infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['units'][unit.name].push(ie.codigo);
                
                if(infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['ies'].indexOf(ie.codigo) == -1){
                  infoReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['ies'].push(ie.codigo);
                }              
              }     
            });
          }           
        });
      }
    );    
    data.curricularUnitPlans.forEach(
      (curricularUnit) => { 
        infoReport.unidadesBase.push(curricularUnit.name);
        curricularUnit.oas.forEach( oa => {
          infoReport.oasbase[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura] = {
            codigo: oa.codigo,
            codigoCategoria: oa.codigoCategoria,
            codigoAsignatura: oa.codigoAsignatura,
          };
          if(!infoReport.oasbase[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['ies']){
            infoReport.oasbase[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['ies'] = [];          }
          oa.ies.forEach( ie => {
            infoReport.oasbase[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['ies'].push(ie.codigo);
          });
        });
      }
    );

    
    Object.keys(infoReport.oasbase).forEach((key, index)=>{
      if(infoReport.oasPlanificados[key]){
        if(infoReport.oasbase[key].ies.length <= infoReport.oasPlanificados[key].ies.length){
          infoReport.oasRealizados.push(infoReport.oasbase[key].codigo);
        }else{
          infoReport.oasEnProceso.push(infoReport.oasbase[key].codigo);
        }
      }else {
        infoReport.oasSinPlanificar.push(infoReport.oasbase[key].codigo);
      }
    });

    infoReport['planAnual'] = {
      'iesCurriculaBase': data.iesCurriculaBase,
      'iesTotalRealizado': data.iesTotalRealizado,
      'iesTotalPlanificado': data.iesTotalPlanificado,
      'iesTotalDefinido': data.iesTotalDefinido,
      // Solo IEs curriculares, para comparar contra la base curricular (fallback si el API no los envía)
      'iesCurriculaRealizado': data.iesCurriculaRealizado != null ? data.iesCurriculaRealizado : data.iesTotalRealizado,
      'iesCurriculaPlanificado': data.iesCurriculaPlanificado != null ? data.iesCurriculaPlanificado : data.iesTotalPlanificado,
    };

    infoReport.aditionalsInProcess = [];
    infoReport.aditionalsRealized = [];
    infoReport.aditionalsNotPlanned = [];

    data.aditionalOAs = orderBy(data.aditionalOAs, ['abreviaturaCategoria', 'codigo'], ['asc']);
    data.aditionalOAs.forEach( oa => {
      const atLeastOneIERealized = oa.ies.some(ie => ie.realizado);
      
      if(atLeastOneIERealized){
        infoReport.aditionalsRealized.push(`${oa.abreviaturaCategoria} ${oa.codigo}`);
      }else if(oa.porcentajeItemsPlanificado > 0){
        infoReport.aditionalsInProcess.push(`${oa.abreviaturaCategoria} ${oa.codigo}`);
      }else{
        infoReport.aditionalsNotPlanned.push(`${oa.abreviaturaCategoria} ${oa.codigo}`);
      }

      let porcentajeItemsRealizado;
      if(oa.ies.length > 0){
        porcentajeItemsRealizado = (oa.ies.filter(ie => ie.realizado).length / oa.ies.length) * 100;
      }

      const aditionalOA = {
        codigo: oa.codigo,
        abreviaturaCategoria: oa.abreviaturaCategoria,
        porcentajeItemsRealizado: porcentajeItemsRealizado,
        iesRealizados: oa.ies.filter(ie => ie.realizado).map(ie => ie.codigo),
      }
      infoReport.aditionalsOAs.push(aditionalOA);
    });

    return infoReport;
  }

  public buildAnualCoverageReport(dataToReport: any): any[] {
    return this.buildDocument(dataToReport);
  }

  public buildDocument(dataToReport: any): any[] {
    let cantRealizados = Object.keys(dataToReport.oasRealizados).length;
    let cantBase = Object.keys(dataToReport.oasbase).length;
    let cantPlanificados = Object.keys(dataToReport.oasPlanificados).length;
    const iesBase = dataToReport.planAnual.iesCurriculaBase || 0;
    const iesRealizado = Math.min(dataToReport.planAnual.iesCurriculaRealizado || 0, iesBase);
    // Lo ejecutado también está planificado
    const iesPlanificado = Math.min(Math.max(dataToReport.planAnual.iesCurriculaPlanificado || 0, iesRealizado), iesBase);
    const iesTotalEjecutadoPercent = iesBase ? Math.floor(iesRealizado * 100 / iesBase) : 0;
    const iesTotalPlanificadoPercent = iesBase ? Math.floor(iesPlanificado * 100 / iesBase) : 0;
    const iesCurriculaBasePercent = 100 - iesTotalPlanificadoPercent;
    const pdfDocument = [
      {
          columnGap: 3,
          columns: [
              {
                width: '*',
                ...this.generalTable({
                    tableContent: {
                        widths: ['*'],
                        heights: ['auto', this.documentHeight / 5 - 35, 'auto'],
                        body: [
                            [
                                this.generalTableHeader({
                                    headerContent: {
                                        text: 'COBERTURA REALIZADA ANUAL',
                                    },
                                    style: ['lightDarkHeader'],
                                }),
                            ],
                            [
                                {
                                    alignment: 'center',
                                    image: BaseReport.buildChart(
                                        this.documentHeight / 5 - 50,
                                        this.documentWidth / 2 + 50,
                                        { 
                                          legend: { 
                                            top: '25%',
                                            left: '40%',
                                            orient: 'vertical',
                                            textStyle: {
                                              fontSize: 10,

                                            },
                                            data: [
                                              iesCurriculaBasePercent + '% No Planificado',
                                              iesTotalPlanificadoPercent + '% Planificado',
                                              iesTotalEjecutadoPercent + '% Ejecutado',
                                            ]
                                          },
                                          grid: {
                                            top: '15%',
                                            left: '1%',
                                            right: '70%',
                                            bottom: '0%',
                                            containLabel: true
                                          },
                                          xAxis: [
                                            {
                                              type: 'category',
                                              show:false,
                                              data: ['']
                                            }
                                          ],
                                          yAxis: [
                                            {
                                              type: 'value',
                                              show:false,
                                            }
                                          ],
                                          series: [
                                              {
                                                type: 'bar',
                                                name: iesTotalEjecutadoPercent + '% Ejecutado',
                                                stack: 'total',
                                                colorBy: 'data',
                                                axisLabel: { show: false },
                                                data: [iesRealizado],
                                              },   
                                              {
                                                type: 'bar',
                                                name: iesTotalPlanificadoPercent + '% Planificado',
                                                stack: 'total',
                                                colorBy: 'data',
                                                axisLabel: { show: false },
                                                data: [iesPlanificado - iesRealizado],
                                              },                                  
                                              {
                                                type: 'bar',
                                                name: iesCurriculaBasePercent + '% No Planificado',
                                                stack: 'total',
                                                colorBy: 'data',
                                                axisLabel: { show: false },
                                                data: [iesBase - iesPlanificado],
                                              },
                                          ],
                                          color: ['#66D485', '#F68F48', '#e4e4e4']
                                        },
                                    ),
                                },
                            ]
                        ],
                    },
                    layout: {
                        paddingLeft: () => 0,
                        paddingRight: () => 0,
                        paddingTop: () => 0,
                        paddingBottom: () => 0,
                        hLineWidth: (i: number) => 1,
                        vLineWidth: (i: number) => 1,
                    },
                }),
              },
          ]
      },
      this.generalTable({
        tableContent: {
            margin: [0, 0, 0, 0],
            widths: ['*'],
            keepWithHeaderRows: 0,
            heights: ['auto', this.documentHeight / 5 - 44, 'auto'],
            body: [
                [ 
                  {
                    table: {
                      widths: ['*', '*', '*'],
                      headerRows: 0,
                      body: [
                        [
                            this.generalTableHeader({
                              headerContent: {
                                  text: 'Estado de Avance',
                                  align: 'center',
                                  fillColor: '#F8F8F8'
                              },
                            }),
                            this.generalTableHeader({
                              headerContent: {
                                  text: 'Curriculares',
                                  align: 'center',
                                  fillColor: '#F8F8F8'
                              },
                            }),
                            this.generalTableHeader({
                              headerContent: {
                                  text: 'Adicionales',
                                  align: 'center',
                                  fillColor: '#F8F8F8'
                              },
                            })
                        ],
                        [
                            this.generalTableHeader({
                                headerContent: {
                                    text: 'REALIZADO',
                                    color: '#00BA34'
                                },
                            }), dataToReport.oasRealizados.sort().join(', '), dataToReport.aditionalsRealized.sort().join(', ')
                        ],
                        [
                            this.generalTableHeader({
                                headerContent: {
                                    text: 'EN PROCESO',
                                    color: '#F47822'
                                },
                            }), dataToReport.oasEnProceso.sort().join(', '), dataToReport.aditionalsInProcess.sort().join(', ')
                        ],
                        [
                            this.generalTableHeader({
                                headerContent: {
                                    text: 'NO PLANIFICADO',
                                },
                            }), dataToReport.oasSinPlanificar.sort().join(', '), dataToReport.aditionalsNotPlanned.sort().join(', ')
                        ],
                      ]
                    },
                    layout: {
                      paddingTop: () => 5,
                      paddingBottom: () => 5,
                      hLineColor: () => '#e0e0e0',
                      vLineColor: () => '#e0e0e0'
                    },
                  }
                ]
            ],
            layout: {
              hLineWidth: (i: number) => 0.1,
              vLineWidth: (i: number) => 0.1,
            },
        },
        layout: {
          hLineWidth: (i: number) => 0,
          vLineWidth: (i: number) => 0,
        },
      }),
      this.generalTable({
        tableContent: {
            widths: [140, '*'].concat(dataToReport.unidadesBase.map((element, i) => (this.documentWidth  - 295)/dataToReport.unidadesBase.length)),
            keepWithHeaderRows: 0,
            body: [
                [
                  this.generalTableHeader({
                    headerContent: {
                        text: 'OBJETIVO DE APRENDIZAJE',
                        fillColor: '#F8F8F8'
                    },
                  }),
                  this.generalTableHeader({
                    headerContent: {
                        text: 'TOTAL',
                        fillColor: '#F8F8F8'
                    },
                  }),
                  ...dataToReport.unidadesBase.sort().map(element => {
                    return this.generalTableHeader({
                      headerContent: {
                          text: element,
                          fillColor: '#F8F8F8'
                      },
                    })
                  })
                    
                ],
                ...Object.values(this.sortObj(dataToReport.oasbase)).map((oa: any) => {
                    return [
                        {
                            text: oa.codigo,
                            alignment: 'center',
                            style: ['parrafo2']
                        },
                        {
                            text: dataToReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura] != undefined ?
                              Math.trunc((dataToReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura].ies.length*100 )/oa.ies.length) +'%' : ' ',
                            alignment: 'center',
                            style: ['parrafo2']
                        },
                        ...dataToReport.unidadesBase.sort().map(element => {
                            return {
                              text: dataToReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura] &&
                              dataToReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['units'][element] ?
                              dataToReport.oasPlanificados[oa.codigo+oa.codigoCategoria+oa.codigoAsignatura]['units'][element].sort().join(', ') : '',
                              alignment: 'center',
                              style: ['parrafo2']
                            }
                        })
                    ];
                }),
            ],
        },
        
        layout: {
            hLineWidth: (i: number) => 1,
            vLineWidth: (i: number) => 1,
        },
      }),
    ]

    if(dataToReport.aditionalsOAs.length > 0){
      pdfDocument.push(this.generalTable({
        tableContent: {
            widths: [80, 45, '*' ],
            keepWithHeaderRows: 0,
            body: [
                [
                  this.generalTableHeader({
                    headerContent: {
                        text: 'OBJETIVOS ADICIONALES',
                    },
                    style: ['lightDarkHeader'],
                  }),
                  this.generalTableHeader({
                    headerContent: {
                        text: 'TOTAL',
                    },
                    style: ['lightDarkHeader'],
                  }),
                  this.generalTableHeader({
                    headerContent: {
                        text: 'IE REALIZADOS',
                    },
                    style: ['lightDarkHeader'],
                  }),
                ],
                ...dataToReport.aditionalsOAs.map((oa: any) => {
                  return [
                      `${oa.abreviaturaCategoria} ${oa.codigo}`,
                      `${oa.porcentajeItemsRealizado != null && oa.porcentajeItemsRealizado != 0 ? oa.porcentajeItemsRealizado + '%' : ''}`,
                      oa.iesRealizados.sort().join(', ')
                  ];
                }),
            ],
        },
        layout: {
          hLineWidth: (i: number) => 1,
          vLineWidth: (i: number) => 1,
        },
      }));
    }
      

    return pdfDocument;


  }


  public sortObj(obj) {
    return Object.keys(obj).sort().reduce(function (result, key) {
      result[key] = obj[key];
      return result;
    }, {});
  }

  public buildFirstSection(dataToReport: any): any[] {
      return [
          {
              columnGap: 3,
              columns: [
                  {
                      width: 'auto',
                      ...this.generalTable({
                          tableContent: {
                              widths: [this.documentWidth / 4 + 15],
                              heights: ['auto', this.documentHeight / 5 - 35, 'auto'],
                              body: [
                                  [
                                      this.generalTableHeader({
                                          headerContent: {
                                              text: 'COBERTURA CURRICULAR ANUAL',
                                          },
                                          style: ['reportPartTitle'],
                                      }),
                                  ],
                                  [
                                      {
                                          alignment: 'center',
                                          image: BaseReport.buildChart(
                                              this.documentHeight / 5 - 50,
                                              this.documentWidth / 4 + 100,
                                              {
                                                  series: [
                                                      {
                                                          type: 'gauge',
                                                          startAngle: 0,
                                                          endAngle: -359.9,
                                                          min: 0,
                                                          max: 100,
                                                          axisLine: {
                                                              lineStyle: {
                                                                  width: 15,
                                                                  color: [
                                                                      [0, '#8E24AA'],
                                                                      [dataToReport.data.anualCurricularPercentage /  100, '#8E24AA'],
                                                                      [dataToReport.data.anualCurricularPercentage /  100, '#C8C8C8'],
                                                                      [1, '#C8C8C8'],
                                                                  ],
                                                              },
                                                          },
                                                          clockwise: true,
                                                          axisLabel: { show: false },
                                                          axisTick: { show: false },
                                                          splitLine: { show: false },
                                                          pointer: false,
                                                          detail: {
                                                              formatter: '{value}%',
                                                              offsetCenter: [0, 0],
                                                              fontSize: 15,
                                                          },
                                                          data: [{
                                                              value: dataToReport.data.anualCurricularPercentage
                                                                  ? dataToReport.data.anualCurricularPercentage : 0,
                                                          }],
                                                      },
                                                  ],
                                              },
                                          ),
                                      },
                                  ],
                                  [
                                      {
                                          text: [
                                              '% DE PLAN ANUAL\n\n',
                                              `${dataToReport.data.user}`,
                                          ],
                                          alignment: 'center',
                                          margin: [10, 0],
                                      },
                                  ],
                                  [
                                      {
                                          text: [
                                              '\n\n',
                                          ],
                                          alignment: 'center',
                                      },
                                  ],
                              ],
                          },
                          layout: {
                              paddingLeft: () => 0,
                              paddingRight: () => 0,
                              paddingTop: () => 0,
                              paddingBottom: () => 0,
                          },
                      }),
                  },
                  {
                      width: '*',
                      ...this.generalTable({
                          tableContent: {
                              widths: ['*'],
                              heights: ['auto', this.documentHeight / 5],
                              body: [
                                  [
                                      this.generalTableHeader({
                                          headerContent: {
                                              text: 'COBERTURA CURRICULAR POR EJE',
                                          },
                                          style: ['reportPartTitle'],
                                      }),
                                  ],
                                  [
                                      {
                                          alignment: 'center',
                                          image: BaseReport.buildChart(
                                              this.documentHeight / 5,
                                              (3 * this.documentWidth / 4) - 70,
                                              {
                                                  grid: {
                                                      top: 15,
                                                      bottom: 20,
                                                      left: 'center',
                                                      width: '98%',
                                                  },
                                                  xAxis: {
                                                      type: 'category',
                                                      axisTick: {
                                                          alignWithLabel: true,
                                                      },
                                                      axisLabel: {
                                                          fontSize: 8,
                                                          interval: 0,
                                                      },
                                                      data: dataToReport.data.ejes.length > 0
                                                          ? dataToReport.data.ejes.map((eje: any) => eje.ejeAbrevation)
                                                          : ['No hay objetivos en la unidad'],
                                                  },
                                                  yAxis: { show: false },
                                                  series: [
                                                      { // For shadow
                                                          type: 'bar',
                                                          barWidth: 25,
                                                          itemStyle: {
                                                              color: 'rgba(0,0,0,0.05)'
                                                          },
                                                          barGap: '-100%',
                                                          barCategoryGap: '40%',
                                                          data: dataToReport.data.ejes.map((eje: any) => 100),
                                                          animation: false
                                                       },
                                                      {
                                                          type: 'bar',
                                                          data: dataToReport.data.ejes.map((eje: any) => eje.ejeDoneCurricularPercentage),
                                                          barWidth: 25,
                                                          label: {
                                                              show: true,
                                                              position: 'top',
                                                              barWidth: 25,
                                                              verticalAlign: 'middle',
                                                              align: 'center',
                                                              formatter: '{c}%',
                                                              color: 'black',
                                                              fontSize: 8,
                                                          },
                                                      },
                                                  ],
                                                  itemStyle: {
                                                      color: darkBarChartColor,
                                                  },
                                              },
                                          ),
                                      },
                                  ],
                                  [
                                      {
                                          text: [
                                              '\n\n',
                                          ],
                                          alignment: 'center',
                                      },
                                  ],
                              ],
                          },
                          layout: {
                              paddingLeft: () => 0,
                              paddingRight: () => 0,
                              paddingTop: () => 0,
                              paddingBottom: () => 0,
                          },
                      }),
                  },
              ],
          },
          {
              ...this.generalTable({
                  tableContent: {
                      widths: ['*'],
                      heights: ['auto', this.documentHeight / 5],
                      body: [
                          [
                              this.generalTableHeader({
                                  headerContent: {
                                      text: 'COBERTURA CURRICULAR POR UNIDAD',
                                  },
                                  style: ['reportPartTitle'],
                              }),
                          ],
                          [
                              {
                                  alignment: 'center',
                                  image: BaseReport.buildChart(
                                      this.documentHeight / 5,
                                      this.documentWidth - (4 * PAGE_MARGIN),
                                      {
                                          xAxis: {
                                              type: 'category',
                                              axisTick: {
                                                  alignWithLabel: 'center',
                                              },
                                              axisLabel: {
                                                  fontSize: 8,
                                              },
                                              data: dataToReport.data.units.map((unitPlan: any) => unitPlan.unitCode),
                                          },
                                          yAxis: { show: false },
                                          series: [
                                              {// For shadow
                                                type: 'bar',
                                                itemStyle: {
                                                  color: 'rgba(0,0,0,0.05)'
                                                },
                                                barGap: '-100%',
                                                barWidth: 25,
                                                data: dataToReport.data.units.map(() => 100),
                                              },

                                              {
                                                  type: 'bar',
                                                  data: dataToReport.data.units
                                                      .map((unitPlan: any) => unitPlan.doneCurricularPercentage),
                                                  barWidth: 25,
                                                  label: {
                                                      show: true,
                                                      position: 'top',
                                                      verticalAlign: 'middle',
                                                      align: 'center',
                                                      formatter: '{c}%',
                                                      color: 'black',
                                                      fontSize: 8,
                                                  },
                                              },
                                          ],
                                          itemStyle: {
                                              color: darkBarChartColor,
                                          },
                                      },
                                  ),
                              },
                          ],
                      ],
                  },
              }),
          },
          this.generalTable({
              tableContent: {
                  widths: ['*', 110, 65, 60, 79],
                  keepWithHeaderRows: 0,
                  body: [
                      [
                          this.generalTableHeaderWithBottomColoredBorder('UNIDAD', darkerLightFirstColumnColor, 'orangeHeader'),
                          this.generalTableHeaderWithBottomColoredBorder('FECHAS', darkerLightFirstColumnColor, 'orangeHeader'),
                          this.generalTableHeaderWithBottomColoredBorder('TOTAL OAS', darkerLightFirstColumnColor, 'orangeHeader'),
                          this.generalTableHeaderWithBottomColoredBorder('% AVANCE', darkerLightFirstColumnColor, 'orangeHeader'),
                          // tslint:disable-next-line:max-line-length
                          this.generalTableHeaderWithBottomColoredBorder('% CURRICULAR', darkerLightFirstColumnColor, 'orangeHeader'),
                      ],
                      ...dataToReport.data.units.map((unitPlan: any) => {
                          return [
                              {
                                  text: unitPlan.unitCode + ' - ' + unitPlan.unitPlanName,
                                  alignment: 'justify',
                              },
                              {
                                  text: unitPlan.startDate.slice(0, 10) + ' - ' + unitPlan.endDate.slice(0, 10),
                                  alignment: 'center',
                              },
                              {
                                  text: unitPlan.totalOAs ? unitPlan.totalOAs : 0,
                                  alignment: 'center',
                              },
                              {
                                  text: (unitPlan.doneUnitPercentage ? unitPlan.doneUnitPercentage : 0) + '%',
                                  alignment: 'center',
                              },
                              {
                                  text: (unitPlan.doneCurricularPercentage ? unitPlan.doneCurricularPercentage : 0) + '%',
                                  alignment: 'center',
                              },
                          ];
                      }),
                  ],
              },
              layout: {
                  hLineWidth: (i: number) => i > 0 ? 3 : 0,
              },
          }),
      ];
  }

  public buildSecondSection(dataToReport: any): any[] {
    return [
      this.generalReportPartTitle({ text: 'COBERTURA CURRICULAR DE OBJETIVOS DE APRENDIZAJE' }),
      this.generalTable({
        tableContent: {
          widths: ['*', 90, 90, 90, 90],
          heights: () => 8,
          keepWithHeaderRows: 0,
          headerRows: 0,
          body: [
            ...dataToReport.data.units.map((unitPlan: any) => {
              return [
                [
                  {
                    text: unitPlan.unitCode + ' - ' + unitPlan.unitPlanName,
                    rowSpan: 4,
                  },
                  {
                    text: 'TRABAJADOS',
                    alignment: 'center',
                    fontSize,
                    fillColor: '',
                  },
                  {
                    text: 'EN PROCESO',
                    alignment: 'center',
                    fontSize,
                    fillColor: '',
                  },
                  {
                    text: 'PENDIENTES',
                    alignment: 'center',
                    fontSize,
                    fillColor: '',
                  },
                  {
                    text: 'NO PLANIFICADOS',
                    alignment: 'center',
                    fontSize,
                    fillColor: '',
                  },
                ],
                [
                  '',
                  {
                    text: unitPlan.OAsDonePercentage + '%',
                    alignment: 'center',
                    fontSize,
                  },
                  {
                    text: unitPlan.OAsInProcessPercentage + '%',
                    alignment: 'center',
                    fontSize,
                  },
                  {
                    text: unitPlan.OAsPendingPercentage + '%',
                    alignment: 'center',
                    fontSize,
                  },
                  '',
                ],
                [
                  '',
                  {
                    text: unitPlan.OAsDone,
                    alignment: 'center',
                    fontSize,
                  },
                  {
                    text: unitPlan.OAsInProcess,
                    alignment: 'center',
                    fontSize,
                  },
                  {
                    text: unitPlan.OAsPending,
                    alignment: 'center',
                    fontSize,
                  },
                  {
                    text: unitPlan.OAsNotPlanned,
                    alignment: 'center',
                    fontSize,
                  },
                ],
                [
                  '',
                  {
                    text: this.getOAsCodes(unitPlan.oas
                      .filter((oa: any) => oa.donePercentage === 100 && oa.puOAStatus === 0)),
                    alignment: 'center',
                    fontSize,
                  },
                  {
                    // tslint:disable-next-line:max-line-length
                    text: this.getOAsCodes(unitPlan.oas.filter((oa: any) => oa.donePercentage > 0 && oa.donePercentage < 100 && oa.puOAStatus === 0)),
                    alignment: 'center',
                    fontSize,
                  },
                  {
                    text: this.getOAsCodes(unitPlan.oas
                      .filter((oa: any) => !oa.oaNotPlanned && oa.donePercentage === 0 && oa.puOAStatus === 0)),
                    alignment: 'center',
                    fontSize,
                  },
                  {
                    text: this.getOAsCodes(unitPlan.oas.filter((oa: any) => oa.oaNotPlanned)),
                    alignment: 'center',
                    fontSize,
                  },
                ],
              ];
            }).flat(),
          ],
        },
        layout: {
          hLineWidth: () => 3,
          vLineWidth: () => 3,
          fillColor: (rowIndex: number, node: any, columnIndex: number) =>
            (rowIndex % 4) === 0 && columnIndex > 0 ? lightColorArray[columnIndex - 1] : '',
        },
      }),
    ];
  }

  public buildThirdSection(dataToReport: any): any[] {
    const uniqueOAs: any[] = orderBy(
      uniqBy(dataToReport.data.units.flatMap((unitPlan: any) => unitPlan.oas), 'OAId'), ['OASubject', 'OACat'],
    );
    return [
      this.generalReportPartTitle({ text: 'COBERTURA CURRICULAR DE OBJETIVOS DE APRENDIZAJE' }),
      this.generalTable({
        tableContent: {
          widths: ['*', 40].concat(dataToReport.data.units.map(() => 30)),
          keepWithHeaderRows: 0,
          body: [
            [
              this.generalTableHeaderWithBottomColoredBorder('Objetivo de Aprendizaje', darkerLightFirstColumnColor, 'orangeHeader'),
              {
                ...this.generalTableHeaderWithBottomColoredBorder('Total\n(%)', darkerLightFirstColumnColor, 'orangeHeader'),
                margin: [0, 0, 0, 0],
              },
              ...dataToReport.data.units.map((unitPlan: any) =>
                // tslint:disable-next-line:max-line-length
                this.generalTableHeaderWithBottomColoredBorder(unitPlan.unitCode, darkerLightFirstColumnColor, 'orangeHeader')),
            ],
            ...uniqueOAs.map((oa) => {
              return [
                {
                  columnGap: 7,
                  alignment: 'left',
                  columns: [
                    {
                      alignment: 'left',
                      text: oa.OACode,
                      bold: true,
                      width: 'auto',
                    },
                    {
                      alignment: 'justify',
                      text: oa.OAName,
                    },
                  ],
                  fontSize,
                },
                { text: oa.OATotalCurricularPercentage + '%', alignment: 'center', fontSize },
                ...dataToReport.data.units.map((unitPlan: any) => {
                  const unitOA = unitPlan.oas.find((unitOAIterated: any) => unitOAIterated.OAId === oa.OAId);
                  if (!unitOA) return '';
                  return {
                    text: unitOA.donePercentage + '%',
                    alignment: 'center',
                    fontSize,
                  };
                }),
              ];
            }),
          ],
        },
        layout: {
          hLineWidth: () => 3,
          fillColor: (rowIndex: number, node: any, columnIndex: number) => columnIndex === 1 ? lightSecondColumnColor : '',
        },
      }),
    ];
  }

  public getOAsCodes(oas: any[]): string {
    return oas.map((oa) => {
      if (oa.IEsfromOAinprogress.length > 0) {
        return oa.OACode +'(' +  this.getIEsCodes(oa.IEsfromOAinprogress) + ')'
      } else {
        return oa.OACode
      }
    }
    ).join(', ');
  }

  public getIEsCodes(ies: any[]): string {
   // Ies todavia no realizados de los OAS in progress"
    return ies.map((ie) => ie[6]).join(', ');
  }
}

export {
  AnualCoverageReport,
};
